﻿const slide = {
  init: function () {
    this.el = document.querySelector("#progress-slider");

    if (this.el === null) return;

    this.slideProgress = this.el.querySelectorAll(".progress-slider__number");
    this.slideItem = this.el.querySelectorAll(".slide__item");
    this.slideButtons = this.el.querySelectorAll(".slide__button");
    this.prevButton = this.slideButtons[0]
    this.nextButton = this.slideButtons[1]

    this.index = 0;
    this.slideCount = this.slideItem.length
    this.n = this.slideCount - 1;

    this.events();
  },

  events: function () {
    for (let i = 0; i < this.slideButtons.length; i++) {
      this.slideButtons[i].addEventListener('click', e => this.onClick(e))
    }

    for (let i = 0; i < this.slideProgress.length; i++) {
      this.slideProgress[i].addEventListener('click', e => this.goTo(e))
    }
  },

  onClick: function (e) {
    let target = e.currentTarget;

    this.slideItem[this.index].classList.toggle("active");
    this.slideProgress[this.index].classList.toggle("active");

    if (this.slideProgress[this.index].nextElementSibling) {
      this.slideProgress[this.index].nextElementSibling.querySelector('.progress-bar').classList.toggle('active')
    }

    target.classList.contains('prev') ? this.prev() : this.next()

    this.slideItem[this.index].classList.toggle("active");
    this.slideProgress[this.index].classList.toggle("active");

    if (this.slideProgress[this.index].nextElementSibling) {
      this.slideProgress[this.index].nextElementSibling.querySelector('.progress-bar').classList.toggle('active')
    }
    
    this.updatePosition()
    this.disable()
  },

  goTo: function (e) {
    let target = e.currentTarget;
    let targetId = target.parentElement.getAttribute('data-id')
    let activeItem = this.el.querySelector('.slide__item.active')
    let activeProgress = this.el.querySelector('.progress-slider__number.active')

    this.index = parseFloat(targetId)

    this.slideItem[targetId].classList.toggle("active");
    this.slideProgress[targetId].classList.toggle("active");
    
    if (this.slideProgress[targetId].nextElementSibling) {
      this.slideProgress[targetId].nextElementSibling.querySelector('.progress-bar').classList.toggle('active')
    }
    
    activeItem.classList.toggle('active')
    activeProgress.classList.toggle('active')
    
    if (activeProgress.nextElementSibling) {
      activeProgress.nextElementSibling.querySelector('.progress-bar').classList.toggle('active')
    }
    
    this.updatePosition()
    this.disable()
  },

  prev: function () {
    if (this.index === 0) {
      this.index = this.n;
    }
    else {
      this.index = this.index - 1;
    }

    return this.index;
  },

  next: function () {
    if (this.index !== this.n) {
      this.index = this.index + 1;
    }
    else {
      this.index = 0;
    }
    
    return this.index;
  },

  timer: function (target, startIndex = 0, slideCount) {
    var timerInterval = 12000;
    var i = startIndex

    var timerFn = function () {
      if (i >= slideCount) {
        clearInterval(timerObj);
      } else {
        target.click()
        i++;
      }
    }

    var timerObj = setInterval(timerFn, timerInterval);

    this.reset = function (newIndex) {
      i = newIndex

      clearInterval(timerObj)
      timerObj = setInterval(timerFn, timerInterval);

      return this;
    }
  },

  updatePosition: function () {
    let processPosition = document.querySelector("[js-process-position]")
    processPosition.textContent = this.index + 1
  },

  disable: function () {
    this.prevButton.removeAttribute('disabled')
    this.nextButton.removeAttribute('disabled')

    if (this.index === 0) {
      this.prevButton.setAttribute('disabled', 'disabled')
      this.nextButton.removeAttribute('disabled')

      // this.autoNext(this.nextButton, 1, this.n)
    }

    if (this.index === this.n) {
      this.nextButton.setAttribute('disabled', 'disabled')
      this.prevButton.removeAttribute('disabled')
    }
  }
};

export default slide.init();
